module.exports = __webpack_public_path__ + "img/lengueta.84f2e1e3.jpeg";